meedy.factory('meedy.errorInterceptor', [ '$q', '$rootScope', 'meedyConfig',
    function ($q, $rootScope, config) {
        return {
            responseError: function (rejection) {
                var ignoreError = false;
                if($rootScope.ignoreError.length > 0) {
                    ignoreError = _.remove($rootScope.ignoreError, function(url) {
                        return rejection.config.url.indexOf(url) > -1;
                    }).length > 0;
                }
                if(!ignoreError) {
                    if(rejection && rejection.status && rejection.status === 401 && rejection.config.url.indexOf('messagebroker/oauth/token') > -1) {
                        //$rootScope.$broadcast(Event.MEEDY.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.INVALID_USER_OR_PASSWORD'));
                    } else if (rejection && rejection.status && (rejection.status === 401 || rejection.status === 403) && isMdxRequest(rejection)) {
                        $rootScope.$broadcast(Event.MEEDY.MDX.MDX_ACCESS_DENIED);
                    } else if (rejection && rejection.status && rejection.status === 403) {
                        $rootScope.$broadcast(Event.MEEDY.ACCESS_DENIED);
                    } else if (rejection && rejection.status && rejection.status === 401) {
                        //Not authorized - to logout
                        $rootScope.$broadcast(Event.MEEDY.FORCE_LOGOUT);
                    } else if (rejection.config && rejection.config.data && rejection.config.data.suppressErrors) {
                        // pass through (angular/JS exception)
                    } else if (rejection && rejection.data && rejection.data[Constant.MEEDY.ERROR_CODE]) {
                        $rootScope.$broadcast(Event.MEEDY.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.' + rejection.data[Constant.MEEDY.ERROR_CODE]));
                    } else {
                        $rootScope.$broadcast(Event.MEEDY.INTERNAL_ERROR, rejection);
                        //$rootScope.$broadcast(Event.NOTIFICATION, new NotificationVO(Enum.NOTIFICATION_TYPE.ERROR, 'T.SYSTEM.NOTIFICATION.OPERATION_FAILED'));
                    }
                }

                function isMdxRequest(rejection) {
                    return rejection.config.url.indexOf(config.MDX_API_URL) > -1 ||
                            rejection.config.url.indexOf(config.AUTH_URL_MDX) > -1
                }

                return $q.reject(rejection);
            }
        }
    }
]);